<template>
  <v-container fluid class="py-0">
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dense class="indigo darken-1 headline">
            <v-toolbar-title class="white--text">
              Commessa Annotazioni
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  label="Note"
                  outlined
                  v-model="annotazioni"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-flex class="text-xs-right"> </v-flex>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    annotazioni_src: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      annotazioni: "",
    };
  },
  watch: {
    annotazioni_src: {
      immediate: true,
      handler() {
        this.annotazioni = this.annotazioni_src;
      },
    },
  },
};
</script>
